import { render, staticRenderFns } from "./ArticlesWaiting.vue?vue&type=template&id=3ce6df70&scoped=true"
import script from "./ArticlesWaiting.vue?vue&type=script&lang=js"
export * from "./ArticlesWaiting.vue?vue&type=script&lang=js"
import style0 from "./ArticlesWaiting.vue?vue&type=style&index=0&id=3ce6df70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6df70",
  null
  
)

export default component.exports